import { Injectable } from '@angular/core';
import { PermissionCheckerService } from '@abp/auth/permission-checker.service';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { LoginService } from "account/login/login.service";

import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild
    } from '@angular/router';

@Injectable()
export class AppRouteGuard implements CanActivate, CanActivateChild {

    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        // private _activatedRoute: ActivatedRoute,
        private _sessionService: AppSessionService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {


        if (state && (UrlHelper.isInstallUrl(state.url) || UrlHelper.isTokenUrl(state.url) || UrlHelper.isRegistrationUrl(state.url) || UrlHelper.isAnnuityPayment(state.url) || UrlHelper.isScheduleUrl(state.url) || UrlHelper.isCertificateValidateUrl(state.url) || UrlHelper.isCart(state.url))) {
            return true;
        }

        if (!this._sessionService.user) {
            this._router.navigate(['/account/login']);
            return false;
        }

        if (!route.data || !route.data['permission']) {
            return true;
        }

        if (this._permissionChecker.isGranted(route.data['permission'])) {
            return true;
        }

        this._router.navigate([this.selectBestRoute()]);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    selectBestRoute(): string {

        if (!this._sessionService.user) {
            return '/account/login';
        }

        if ( this._permissionChecker.isGranted('Pages.Application.Host.Dashboard') ||
             this._permissionChecker.isGranted('Pages.Application.Member.Host.Dashboard') ||
             this._permissionChecker.isGranted('Pages.Application.Annuity.Host.Dashboard') ||
             this._permissionChecker.isGranted('Pages.Application.Event.Host.Dashboard') ||
             this._permissionChecker.isGranted('Pages.Application.Cientific.Host.Dashboard') ||
             this._permissionChecker.isGranted('Pages.Application.Financial.Host.Dashboard')
            ){
            return '/app/admin/hostDashboard';
        }

        if (this._permissionChecker.isGranted('Pages.Application.Tenant.Dashboard')) {
            return '/app/main/dashboard';
        }

        if (this._permissionChecker.isGranted('Pages.Application.Tenants')) {
            return '/app/admin/tenants';
        }

        if (this._permissionChecker.isGranted('Pages.Administration.Users')) {
            return '/app/admin/users';
        }

        if (this._permissionChecker.isGranted('Pages.Events.Events')) {
            return '/app/event/events';
        }

        if (this._permissionChecker.isGranted('Pages.Annuities.Annuities')) {
            return '/app/annuity/annuities';
        }

        if (this._permissionChecker.isGranted('Pages.Financial.PaymentCharges')) {
            return '/app/financial/receivables';
        }

        if (this._permissionChecker.isGranted('Pages.Scientific.Programmings')) {
            return '/app/scientific/programmings';
        }

        if (this._permissionChecker.isGranted('Pages.ScientificWorks.EventWorks')) {
            return '/app/scientificWork/eventWorks';
        }

        return '/app/notifications';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/auth/auth-route-guard.ts